const MODEL_CREDITS = [
    ["15th - Fall // Banana Peel", "Ringo Gunther", "https://skfb.ly/6Wv8H"],
    ["Blood Pack (Low-poly PBR)", "RetroDesignHive", "https://skfb.ly/osRWn"],
    ["Tree low poly lowpoly", "00amza", "https://skfb.ly/pO6MX"],
    ["Nail", "WBF Solutions & Design", "https://skfb.ly/oGGr7"],
    ["Water balloon", "Manuagc", "https://skfb.ly/6x6NY"],
    ["Mirror", "Gabriela_Ojeda", "https://skfb.ly/ooOKA"],
    ["Slingshot", "justincrazyeyes", "https://skfb.ly/oosNB"],
    ["Glass Bottle", "LightSwitch", "https://skfb.ly/6UA9R"],
    ["Coin", "rukitu", "https://skfb.ly/oqGSQ"],
    ["fire", "Edgar_koh", "https://skfb.ly/6V9OK"],
    ["Kuntilanak Merah (Scary)", "fdhlan21", "https://skfb.ly/pIwIx"],
    ["Pocong (Scary)", "fdhlan21", "https://skfb.ly/pIwFT"],
    ["Krasue Eyes", "MakeCrow", "https://skfb.ly/oT6SG"],
    ["Low-Poly Insecticide Spary", "Ronstu", "https://skfb.ly/pLw9X"],
] as const;

// Scoped mobile overrides; existing desktop stylesheet remains authoritative.
const CREDITS_MOBILE_STYLES = `
<style data-credits-mobile-style>
@media (max-width: 600px) {
  .credits-screen {
    position: relative !important;
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    height: 100dvh !important;
    min-height: 0 !important;
    overflow-x: hidden !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-y: contain;
    box-sizing: border-box;
    padding: calc(env(safe-area-inset-top, 0px) + 12px) 12px
             calc(env(safe-area-inset-bottom, 0px) + 28px) !important;
    align-items: initial !important;
    justify-content: initial !important;
  }
  .credits-screen *, .credits-screen *::before, .credits-screen *::after {
    box-sizing: border-box;
  }
  .credits-screen .credits-card {
    display: block !important;
    position: relative !important;
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    height: auto !important;
    min-height: 0 !important;
    max-height: none !important;
    margin: 0 !important;
    padding: 14px !important;
    overflow: visible !important;
  }
  .credits-screen .credits-header {
    display: flex !important;
    flex-direction: column !important;
    align-items: stretch !important;
    gap: 8px !important;
    position: static !important;
    padding: 0 0 12px !important;
    margin: 0 0 12px !important;
  }
  .credits-screen .credits-header .back {
    position: static !important;
    inset: auto !important;
    transform: none !important;
    align-self: flex-start !important;
    width: auto !important;
    min-height: 44px;
    margin: 0 !important;
    padding: 7px 12px !important;
  }
  .credits-screen .credits-header > div {
    min-width: 0;
    width: 100%;
  }
  .credits-screen .credits-header .eyebrow {
    margin: 0 0 3px !important;
    font-size: 11px !important;
    letter-spacing: .15em;
  }
  .credits-screen .credits-header h2 {
    margin: 0 !important;
    font-size: clamp(25px, 7vw, 32px) !important;
    line-height: 1.12 !important;
    overflow-wrap: anywhere;
  }
  .credits-screen .credits-intro {
    margin: 4px 0 0 !important;
    font-size: 13px !important;
    line-height: 1.45 !important;
    overflow-wrap: anywhere;
  }
  .credits-screen .credit-section {
    margin: 0 0 16px !important;
    padding: 0 !important;
    min-width: 0 !important;
  }
  .credits-screen .credit-section > h3 {
    margin: 0 0 8px !important;
    font-size: 19px !important;
    line-height: 1.25 !important;
    overflow-wrap: anywhere;
  }
  .credits-screen .credit-section > h3 span {
    font-size: 12px !important;
  }
  .credits-screen .credit-list {
    display: grid !important;
    grid-template-columns: minmax(0, 1fr) !important;
    gap: 8px !important;
    width: 100% !important;
    align-items: start !important;
  }
  .credits-screen .credit-list article {
    display: flex !important;
    flex-direction: column !important;
    gap: 3px !important;
    position: static !important;
    width: 100% !important;
    min-width: 0 !important;
    min-height: 0 !important;
    height: auto !important;
    padding: 11px 12px !important;
    margin: 0 !important;
    overflow-wrap: anywhere;
    word-break: normal;
  }
  .credits-screen .credit-list article h3 {
    margin: 0 !important;
    font-size: 15px !important;
    line-height: 1.35 !important;
  }
  .credits-screen .credit-list article p {
    margin: 0 !important;
    font-size: 13px !important;
    line-height: 1.45 !important;
  }
  .credits-screen .credit-list article .credit-source {
    position: static !important;
    inset: auto !important;
    transform: none !important;
    margin-top: 5px !important;
    padding: 0 !important;
    font-size: 13px !important;
    align-self: flex-start;
  }
  .credits-screen .special-credit .credit-list article {
    gap: 2px !important;
  }
  .credits-screen .license-note,
  .credits-screen .tech-credit {
    font-size: 12px !important;
    line-height: 1.5 !important;
    overflow-wrap: anywhere;
    margin: 8px 0 !important;
  }
  .credits-screen a { overflow-wrap: anywhere; }
}
</style>`;

export class CreditsScreen {
    constructor(
        private readonly root: HTMLElement,
        private readonly onBack: () => void,
    ) { }

    show(): void {
        const models = MODEL_CREDITS.map(([title, creator, link]) =>
            title === "Mirror"
                ? `<article><h3>${title}</h3><p><a href="${link}" target="_blank" rel="noopener noreferrer">“Mirror”</a> oleh ${creator} · <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank" rel="noopener noreferrer">Creative Commons Attribution 4.0</a></p><a class="credit-source" href="${link}" target="_blank" rel="noopener noreferrer">Model asal ↗</a></article>`
                : `<article><h3>${title}</h3><p>oleh ${creator}</p><a class="credit-source" href="${link}" target="_blank" rel="noopener noreferrer">Model asal ↗</a></article>`
        ).join("");

        this.root.innerHTML = `${CREDITS_MOBILE_STYLES}
      <main class="screen sub-screen credits-screen">
        <section class="wide-card glass-panel credits credits-card">
          <header class="credits-header">
            <button class="back" type="button" aria-label="Kembali ke menu sebelumnya">← Kembali</button>
            <div>
              <p class="eyebrow">PENGHARGAAN</p>
              <h2>Kredit &amp; Lesen</h2>
            </div>
            <p class="credits-intro">Permainan, kod dan peta hutan prosedural dihasilkan khas untuk <em>Penangkap Hantu</em>.</p>
          </header>

          <section class="credit-section special-credit">
            <h3>SPECIAL CREDIT</h3>
            <div class="credit-list"><article>
            <p>Akim Fixie - Idea, QA</p>
            <p>Kamal Kobra - Idea, QA and Opening cutscene</p>
            </article></div>
          </section>

          <section class="credit-section model-credits">
            <h3>Model 3D <span>· CC BY 4.0</span></h3>
            <div class="credit-list">${models}</div>
            <p class="license-note">Semua model 3D di atas dilesenkan di bawah <a href="https://creativecommons.org/licenses/by/4.0/" target="_blank" rel="noopener noreferrer">Creative Commons Attribution 4.0</a>. Skala, orientasi dan pencahayaan disesuaikan pada masa jalan; fail sumber tidak diubah.</p>
          </section>

          <section class="credit-section share-alike-credits">
            <h3>Model CC BY-SA 4.0</h3>
            <div class="credit-list">
              <article>
                <h3>Candle Light Animated</h3>
                <p>oleh CΛTΞИCOΔΞ · <a href="https://creativecommons.org/licenses/by-sa/4.0/" target="_blank" rel="noopener noreferrer">Creative Commons Attribution-ShareAlike 4.0</a></p>
                <a class="credit-source" href="https://skfb.ly/69TFS" target="_blank" rel="noopener noreferrer">Model asal ↗</a>
              </article>
              <article>
                <h3>Trampoline</h3>
                <p>oleh 1-3D.com · <a href="https://creativecommons.org/licenses/by-sa/4.0/" target="_blank" rel="noopener noreferrer">Creative Commons Attribution-ShareAlike 4.0</a></p>
                <a class="credit-source" href="https://skfb.ly/otLYp" target="_blank" rel="noopener noreferrer">Model asal ↗</a>
              </article>
            </div>
            <p class="license-note">Skala dan penempatan tanah disesuaikan pada masa jalan. Perubahan tertakluk pada CC BY-SA 4.0.</p>
          </section>

          <section class="credit-section audio-credits">
            <h3>Audio &amp; Sound Effects</h3>
            <div class="credit-list">
              <article><h3>Real Kg Sanggang night audio</h3><p>Sanggang.wav</p></article>
              <article>
                <h3>Toyol Escape Laughter</h3>
                <p>Sound Effect by <a href="https://pixabay.com/users/dragon-studio-38165424/" target="_blank" rel="noopener noreferrer">DRAGON-STUDIO</a> from Pixabay.</p>
                <a class="credit-source" href="https://pixabay.com/sound-effects/401714/" target="_blank" rel="noopener noreferrer">Rujukan bunyi asal ↗</a>
              </article>
              <article>
                <h3>Woman Scream Sound HD</h3>
                <p>Sound Effect by <a href="https://pixabay.com/users/virtual_vibes-51361309/" target="_blank" rel="noopener noreferrer">Dilip</a> from Pixabay.</p>
                <a class="credit-source" href="https://pixabay.com/sound-effects/379381/" target="_blank" rel="noopener noreferrer">Rujukan bunyi asal ↗</a>
              </article>
            </div>
            <p class="license-note">Audio Pixabay digunakan mengikut Lesen Kandungan Pixabay dan tidak dilabel sebagai CC BY 4.0.</p>
          </section>

          <p class="tech-credit">Dibangunkan dengan Babylon.js, TypeScript dan Vite.</p>
        </section>
      </main>`;

        this.root.querySelector<HTMLButtonElement>(".credits-screen .back")
            ?.addEventListener("click", this.onBack);
    }
}
